import React, { useState } from "react";
import { Container } from "react-bootstrap";
import shiptime from "../../../../Asset/d2c/Customised-Web-Development-1.png";
import welness from "../../../../Asset/d2c/Mobile-Commerce-Solutions-1.png";
import movie from "../../../../Asset/d2c/Group-290573-1.png";
import finfolio from "../../../../Asset/d2c/Payment-Gateway-Integration-1.png";
import tuki from "../../../../Asset/d2c/Search-Engine-Optimization-SEO-1.png";
import paid from "../../../../Asset/d2c/Support-and-Maintenance-1.png";
import "./Sixth.css";

const industriesData = [
  {
    key: "Customised Web Development",
    title:
      "Your D2C brand is unique, and your website should reflect its distinct identity.",
    description:
      "At Codeffi, we design and develop fully customized websites that align perfectly with your brand's specific needs and target audience. Our skilled professionals create websites with us.",
    image: shiptime,
    backgroundColor: "var(--light-gray-color)",
  },
  {
    key: "Mobile Commerce Solutions",
    title:
      "Engage customers on-the-go with your user-centric mobile app that drives growth.",
    description:
      "We ensure that your D2C brand provides an engaging shopping experience to your customers anytime, anywhere. Our expert team creates mobile apps with us.",
    image: welness,
    backgroundColor: "var(--light-gray-color)",
  },
  {
    key: "eCommerce Platform Integration",
    title:
      "Grow your online D2C store on any leading eCommerce platform of your choice.",
    description:
      "Our integration services allow you to leverage the robust features of these established platforms while customizing your store to meet your unique business needs. Our seasoned professionals excel in cutting-edge technologies, including.",
    image: movie,
    backgroundColor: "var(--light-gray-color)",
  },
  {
    key: "Payment Gateway Integration",
    title:
      "Ensure secure and seamless payment transactions for your D2C brand with our expert payment gateway integration services.",
    description:
      "This helps you enhance user satisfaction, build brand trust & loyalty and increase conversion rates. We seamlessly integrate industry-leading payment gateways, including.",
    image: finfolio,
    backgroundColor: "var(--light-gray-color)",
  },
  {
    key: "Search Engine Optimization (SEO)",
    title:
      "Boost your online visibility and drive organic traffic to your D2C brand with our expert SEO services.",
    description:
      "Our data-driven SEO promises increased qualified leads, higher ROI and a long-term, sustainable growth. Our comprehensive services include.",
    image: tuki,
    backgroundColor: "var(--light-gray-color)",
  },
  {
    key: "Support and Maintenance",
    title:
      "Your D2C success story doesn't end here. Our dedicated ongoing support ensures your D2C eCommerce brand remains cutting-edge, secure, and optimized for peak performance.",
    description: "Our proactive support includes.",
    image: paid,
    backgroundColor: "var(--light-gray-color)",
  },
];

const Sixth = () => {
  const [activeTab, setActiveTab] = useState("Customised Web Development");
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleTabClick = (tab) => {
    if (tab !== activeTab) {
      setIsTransitioning(true);
      setTimeout(() => {
        setActiveTab(tab);
        setIsTransitioning(false);
      }, 100);
    }
  };

  const activeIndustry = industriesData.find(
    (industry) => industry.key === activeTab
  );
  return (
    <>
      <section className="second third-extra-indus-section">
        <Container>
          <div className="top-text-after-fourth-services">
            <h2>
              D2C ECOMMERCE <span> DEVELOPMENT SERVICES </span>
            </h2>
          </div>
          <p className="top-paragraph-d2c">
            We empower your D2C brand to boost it's online presence, create
            seamless shopping experience, drive revenue growth.
          </p>
          <div className="row align-items-start">
            <div className="col-lg-3 col-xl-3">
              <div className="align-items-start industry-tab-sec">
                <ul className="nav flex-column nav-pills me-3 industris-list">
                  {industriesData.map((industry) => (
                    <li
                      key={industry.key}
                      className={`nav-link d-block text-left w-100 ${
                        activeTab === industry.key ? "active" : ""
                      }`}
                      onClick={() => handleTabClick(industry.key)}
                    >
                      {industry.key.charAt(0).toUpperCase() +
                        industry.key.slice(1)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-9 col-xl-9">
              <div className="main-slider">
                <div
                  className={`industries-content-wrapper d-flex flex-wrap p-5 myclass ${
                    isTransitioning ? "fade-out" : "fade-in"
                  }`}
                  style={{ backgroundColor: activeIndustry.backgroundColor }}
                >
                  <div className="industry-partner-wrapper w-50 pr-3">
                    <div className="industry-partner-text">
                      <h4>
                        <b>{activeIndustry.title}</b>
                      </h4>
                      <p>{activeIndustry.description}</p>
                    </div>
                  </div>
                  <div className="industries-detail d-flex w-50 pl-lg-3 mt-0">
                    <div className="industries-detail-img">
                      <img
                        alt="main"
                        src={activeIndustry.image}
                        className="w-100"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Sixth;
